import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import React, { FunctionComponent, useState } from 'react'
import { Label } from "@progress/kendo-react-labels";
import { ClientApi } from '../../redux/api/ClientApi';
import { Api } from '../../redux/api/BaseApi';
import {
    Hint,
} from "@progress/kendo-react-labels";

const ClientTypeList: FunctionComponent<FieldRenderProps> = props => {
    const {
        label,
        id,
        valid,
        disabled,
        optional,
        clientTypeIds,
        onChange,
        placeholder,
        ...others
    } = props;

    const { data: userProfile } = Api.useGetUserProfileQuery();
    const [opened, setOpened] = useState(false);
    const [values, setValues] = useState([]);
    const { data: clientTypes } = ClientApi.useGetClientTypesQuery()
    const selectClientTypes = clientTypes?.filter(ct => clientTypeIds?.indexOf(ct.ID) > -1);

    const handleSingleChange = (event) => {
        console.log('handleSingleSelect', event)
        let foundItem = values.filter(v => v.ID === event.value.ID)
        let newArray = [...values] //clone

        if (foundItem?.length > 0) {
            newArray.splice(values.indexOf(foundItem[0]), 1)
            setValues(newArray);
        }
        else {
            newArray = [...values, event.value]
            setValues(newArray);
        }
    }

    const itemRender = (li, itemProps) => {
        let foundItem = values?.filter(v => v.ID === itemProps.dataItem["ID"])
        const itemChildren = (
            <span>
                <input type="checkbox" checked={foundItem?.length > 0} onChange={() => console.log('Changed')}
                    onMouseDown={(e) => { e.preventDefault(); }}
                />
                &nbsp;{li.props.children}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    const ctFilterChangeHandler = (e) => {
        console.log('ctFilterChangeHandler', e)
    }

    return (
        <FieldWrapper>
            <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}>
                {label}
            </Label>
            {/* <DropDownList opened={opened}
                onFocus={() => { setOpened(true) }}
                onBlur={() => { setOpened(false) }}
                title={values.map(v => v.Company_Type_Name).join(', ')}
                value={!values?.length ? { Company_Type_Name: 'Filter...' } : values?.length === 1 ? { ID: 0, Company_Type_Name: 'Check All' } : { Company_Type_Name: `${values?.length} items selected` }}
                data={clientTypes}
                textField="Company_Type_Name"
                itemRender={itemRender}
                defaultItem={{ ID: 0, Company_Type_Name: 'Check All' }}
                onChange={handleSingleChange}
            /> */}
            <MultiSelect onChange={onChange}
                disabled={disabled}
                opened={opened}
                value={selectClientTypes}
                onFocus={() => { setOpened(true) }}
                onBlur={() => { setOpened(false) }}
                placeholder={placeholder || 'Filter...'}
                data={clientTypes}
                textField="Company_Type_Name"
            />
            {disabled && (
                <Hint direction={"start"}>
                    Settings are not editable due to {userProfile?.Phrases.CallPhrase} Access Control permissions
                </Hint>
            )}
        </FieldWrapper>
    )
}

export default ClientTypeList